import { BoxContainer, TextField } from '@components/common';
import css from './index.module.scss';
import { Controller, useFormContext } from 'react-hook-form';
import { IconNode } from '@components/base';
import Images from '@assets/images';

const CarrierInfo = () => {
  const { control } = useFormContext();
  return (
    <BoxContainer className={css.mainWrapper} title="Carrier Information">
      <div className={css.boxWrapper}>
        <div className={css.rowWrapper}>
          <Controller
            name="carrierInfo.name"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Carrier Name"
                placeholder="Carrier Name"
                required
                error={fieldState.invalid}
                endIcon={
                  fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                }
                helperText={fieldState.error?.message}
              />
            )}
          />
          <Controller
            name="carrierInfo.quoteId"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Carrier Quote ID"
                placeholder="Carrier Quote ID"
                error={fieldState.invalid}
                endIcon={
                  fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                }
                helperText={fieldState.error?.message}
              />
            )}
          />
        </div>
      </div>
    </BoxContainer>
  );
};

export default CarrierInfo;
